var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',_vm._l((_vm.divList),function(v,k){return _c('v-col',{key:k,attrs:{"cols":"12"}},[_c('v-card',{staticClass:"card-size pa-2 overflow-auto"},[_c('div',{attrs:{"id":v}})])],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }